var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcbcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7662 21.8973C34.7662 24.8724 32.3437 27.295 29.3686 27.295H0V5.91673C0 2.94163 2.42259 0.519043 5.39769 0.519043H34.7662V21.8973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2031 16.415H27.4344C27.4982 16.415 27.6469 16.3938 27.7107 16.3938C28.1357 16.3088 28.4969 15.9263 28.4969 15.395C28.4969 14.885 28.1357 14.5025 27.7107 14.3963C27.6469 14.375 27.5194 14.375 27.4344 14.375H25.2031V16.415Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1799 2.32422C25.0548 2.32422 23.3123 4.04554 23.3123 6.19188V10.2083H28.7737C28.9012 10.2083 29.05 10.2083 29.1562 10.2295C30.3888 10.2933 31.3026 10.9308 31.3026 12.0359C31.3026 12.9072 30.6863 13.6509 29.5387 13.7997V13.8422C30.7925 13.9272 31.7488 14.6285 31.7488 15.7123C31.7488 16.8811 30.6863 17.6461 29.2837 17.6461H23.291V25.5089H28.965C31.09 25.5089 32.8326 23.7876 32.8326 21.6413V2.32422H27.1799Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2208 12.2905C28.2208 11.7805 27.8595 11.4405 27.4345 11.3767C27.392 11.3767 27.2857 11.3555 27.222 11.3555H25.2031V13.2256H27.222C27.2857 13.2256 27.4132 13.2256 27.4345 13.2043C27.8595 13.1406 28.2208 12.8005 28.2208 12.2905Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.801 2.32422C3.67592 2.32422 1.93336 4.04553 1.93336 6.19186V15.7334C3.01715 16.2647 4.14344 16.6047 5.26973 16.6047C6.60853 16.6047 7.33105 15.7972 7.33105 14.6922V10.187H10.6462V14.6709C10.6462 16.4135 9.56238 17.8373 5.886 17.8373C3.65467 17.8373 1.91211 17.3485 1.91211 17.3485V25.4875H7.58606C9.71114 25.4875 11.4537 23.7662 11.4537 21.6199V2.32422H5.801Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4907 2.32422C14.3656 2.32422 12.623 4.04553 12.623 6.19186V11.2495C13.6006 10.4208 15.3006 9.88949 18.042 10.017C19.5083 10.0807 21.0808 10.4845 21.0808 10.4845V12.1208C20.2946 11.7171 19.3595 11.3558 18.1482 11.2708C16.0657 11.122 14.8119 12.1421 14.8119 13.9271C14.8119 15.7334 16.0657 16.7535 18.1482 16.5835C19.3595 16.4985 20.2946 16.116 21.0808 15.7334V17.3698C21.0808 17.3698 19.5295 17.7735 18.042 17.8373C15.3006 17.9648 13.6006 17.4335 12.623 16.6047V25.53H18.297C20.4221 25.53 22.1646 23.8087 22.1646 21.6624V2.32422H16.4907Z",
    fill: "url(#paint4_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.3082,
    y1: 15.3976,
    x2: 32.8577,
    y2: 15.3976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 23.3084,
    y1: 13.9072,
    x2: 32.8587,
    y2: 13.9072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 23.308,
    y1: 12.2878,
    x2: 32.858,
    y2: 12.2878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1.9289,
    y1: 13.9072,
    x2: 11.6263,
    y2: 13.9072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 12.568,
    y1: 13.9072,
    x2: 21.9866,
    y2: 13.9072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbcard);
export default __webpack_public_path__ + "static/media/jcbcard.b1b3f41a.svg";
export { ForwardRef as ReactComponent };